// extracted by mini-css-extract-plugin
export default {"calendar_wrapper":"Gq","modify_order":"Hq","modify_order_header":"Iq","product_details_form_wrapper":"Jq","c_wrapper":"Kq","save_button":"Lq","title":"Mq","modify_order_title_wrapper":"Nq","note":"Oq","buttons_wrapper":"Pq"};
    if(module.hot) {
      // 1721922359629
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  